export const UNSTABLE = {
  'logistics-frontend': {
    default: 'logistics-frontend.taxi.dev.yandex.net',
    authorized: 'logistics-frontend.taxi.dev.yandex.ru',
  },
  'static-com': {
    default: 'static-com.taxi.dev.yandex.net',
    authorized: 'delivery.dev.yandex.com',
    by: 'delivery.dev.yandex.by',
    kg: 'delivery.dev.yandex.kg',
    kz: 'delivery.dev.yandex.kz',
    uz: 'delivery.dev.yandex.uz',
  },
  'static-ru': {
    default: 'frontend-static-yango.taxi.dev.yandex.net',
  },
  'static-yango': {
    default: 'static-yango.taxi.dev.yandex.net',
    authorized: 'delivery.dev.yango.com',
  },
} as const
